import UserTransfer from './user-transfer.vue'
UserTransfer.install = function (Vue) {
  Vue.component(UserTransfer.name, UserTransfer);
};
export default UserTransfer



// WEBPACK FOOTER //
// ./src/omnis-business/user-transfer/index.js